<template>
    <div class="warp" :style ='{height:(this.$store.state.windowHeight-this.$store.state.topBlockHeight-70)+"px"}'>
       <div class="content common-space-between" v-if="show">
           <div class="left-block" :style ='{width:(this.$store.state.windowwidth-this.$store.state.leftBlockWidth-50)*0.6486+"px",}'>
                 
                <div class="common-bottom">
                    <UserBlock></UserBlock>
                </div>
                <!--用户概况-->
                <div class="common-bottom">
                     <ChartUser></ChartUser>
                </div>
                <!-- 设备报警情况 -->
                <div class="common-bottom">
                     <ChartEqum></ChartEqum>
                </div>
                <!-- 报警处理情况 -->
                <div>
                     <Chartlice></Chartlice>
                </div>
           </div>
           <div class="right-block" :style ='{width:(this.$store.state.windowwidth-this.$store.state.leftBlockWidth-50)*0.3514+"px",}'>
                <!--中国地图-->
               <div class="common-bottom">
                  <ChinaMap></ChinaMap>
               </div>
               <!--设备占比-->
               <div class="common-bottom">
                   <EQBlock></EQBlock>
               </div>
               <!--工厂占比-->
               <div class="">
                   <FaBlock></FaBlock>
                </div>
           </div> 
       </div>
    </div>
</template>
<script>
import UserBlock  from './common-module/block-left/block-user.vue'
import ChartUser  from './common-module/block-left/chart-user/block-index.vue' 
import ChartEqum  from './common-module/block-left/chart-equment/block-index.vue'
import Chartlice  from './common-module/block-left/chart-police/block-index.vue'  
import EQBlock    from './common-module/block-right/block-equipment.vue'
import FaBlock    from './common-module/block-right/block-factory.vue'
import ChinaMap   from './common-module/block-right/block-ChinaMap.vue'
export default {
    components:{
        UserBlock:UserBlock,
        EQBlock:EQBlock,
        FaBlock:FaBlock,
        ChinaMap:ChinaMap,
        ChartUser:ChartUser,
        ChartEqum:ChartEqum,
        Chartlice:Chartlice
    },
    data () {
        return {
           show:true,
           deviceCount:0,
           deviceTypeCount:0, 
           factoryCount:0,
           projectCount:0,
        }
    },
    created(){
      
    },
    methods:{
        
    },
}
</script>
<style lang="scss" scoped>
    .warp{
       overflow-y: auto;
       padding:0px;
       box-sizing: border-box;
       border-radius: 10px;
       background-size: cover;
       background-image: url("./../../../assets/custom-image/indexBack.svg");
       background-repeat: no-repeat;  
       .left-block{
        width: 68%; 
        margin-right: 20px; 
       }
       .right-block{
        flex:1;
       }  
    }
    .hengblock{
        width: calc(50% - 10px);
    }
    .common-bottom{
        margin-bottom: 20px;
    }
</style>
